export default {
    setOrders: (state, param) => {
        console.log('smallreducer SEt')
        const {payload} = param;
        return state.data = payload;
    },
    addOrdersList: (state, param) => {
        const {payload} = param;
        console.log('smallreducer')
        return state.data = {...state.data,...payload};
    },
    setOrder: (state, param) => {
        const {payload} = param;
        state.data[payload.id] = payload
    },
    clearFilters: (state) => {
        console.log('smallreducerClear')
        state.queryParams = {perPage: 25, page: 1, sort: 'createdAt', sortDirection:'DESC', orderStatusId: null, createdAt_max: null}
    }
}
